import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import useAgentEditFormUtil, { IFormValue } from "./use-agent-edit-form.util";
import FormFields from "./components/form-fields";
import FormButtons from "./components/form-buttons";
import { IUser } from "../../../../../../../services/microservice/admin/types/admin.types";

interface IProps {
  user: IUser | undefined;
}

const AgentEditForm = ({ user }: IProps) => {
  const { validationSchema, submitForm, isLoading } = useAgentEditFormUtil();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: user?.name,
      email: user?.email,
      password: user?.password,
      phoneNumber: user?.phone_number,
      role: user?.roles[0],
      sponsor: user?.sponsor,
    },
    resolver: yupResolver(validationSchema),
  });
  return (
    <div className="w-full">
      <form onSubmit={handleSubmit(submitForm)}>
        <FormFields control={control} errors={errors} />
        <div className="flex flex-grow items-center justify-end">
          <FormButtons isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
};

export default AgentEditForm;
